import React, { useEffect, useRef, useState } from "react";
import { FiMoon, FiSun } from "react-icons/fi";
import { useThemeStore } from "../../store/themeStore";
import { authStore, useAuthStore } from "../../store/authStore";
import { api } from "../../utils/api";
import { toast } from "react-toastify";
import "./ThemeToggle.css";

const ThemeToggle = () => {
  const { theme } = useThemeStore();
  const { user } = useAuthStore();
  const [saving, setSaving] = useState(false);
  const saveLock = useRef(false);
  const mounted = useRef(true);
  const isDark = theme === "dark";

  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  const handleToggle = async () => {
    if (saveLock.current || !user?.user_id) return;
    const nextTheme = theme === "dark" ? "light" : "dark";
    saveLock.current = true;
    setSaving(true);
    try {
      const response = await api.put(`/user/theme/${user.user_id}`, { theme: nextTheme });
      const result = await response.json();
      if (!response.ok || result?.status === false) {
        throw new Error(result?.message || "Unable to save theme preference");
      }
      authStore.updateUserTheme(nextTheme, user.user_id, user.company_id);
    } catch (error) {
      if (mounted.current) toast.error(error.message || "Unable to save theme preference");
    } finally {
      saveLock.current = false;
      if (mounted.current) setSaving(false);
    }
  };

  return (
    <div className="theme-toggle-card">
      <div className="theme-toggle-icon">{isDark ? <FiMoon /> : <FiSun />}</div>

      <div className="theme-toggle-text">
        <p className="theme-toggle-title">Theme</p>
        <p className="theme-toggle-sub">{isDark ? "Dark mode" : "Light mode"}</p>
      </div>

      <button
        type="button"
        role="switch"
        aria-checked={isDark}
        aria-label="Toggle dark mode"
        className={`theme-switch ${isDark ? "on" : ""}`}
        onClick={handleToggle}
        disabled={saving || !user?.user_id}
        aria-busy={saving}
      >
        <span className="theme-switch-knob">
          {isDark ? <FiMoon /> : <FiSun />}
        </span>
      </button>
    </div>
  );
};

export default ThemeToggle;
